import mixpanel from 'mixpanel-browser';
const projectToken = '88b813d095de3ae5b0ec0e178bd46db1';
mixpanel.init(projectToken);
export default mixpanel;